/**
 * The multipart part name `POST /api/files/upload` reads its files from: the gateway declares
 * `@RequestParam("files") List<MultipartFile> files`. A request carrying the file under any other
 * name reaches the controller with no part at all and fails as an unexpected error, which is what
 * the client saw as "Une erreur inattendue est survenue" when adding a crypto address.
 *
 * Shared with nothing else on purpose: the profile document upload already spells it right in
 * `fileApi.ts`; this module exists so the crypto proof cannot drift from the contract again and
 * can be tested without the axios instance.
 */
export const FILES_UPLOAD_PART = 'files';

/** Builds the body of the proof upload: exactly one part, named as the API expects. */
export const buildCryptoProofFormData = (file: File | Blob, fileName?: string): FormData => {
  const formData = new FormData();
  if (fileName) formData.append(FILES_UPLOAD_PART, file, fileName);
  else formData.append(FILES_UPLOAD_PART, file);
  return formData;
};
